import React, { Component } from 'react'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'

import Tooltip from '@components/Tooltip'
import InfoIcon from '@components/Icon/Info'

class Paragraph extends Component {
  static propTypes = {
    title: PropTypes.string,
    value: PropTypes.string,
    tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  }

  static defaultProps = {
    value: '-'
  }

  renderTooltip = () => {
    if (!this.props.tooltip) return null
    return (
      <Tooltip tooltip={this.props.tooltip}>
        <div className='iconWrapper'>
          <InfoIcon />
        </div>
      </Tooltip>
    )
  }

  render () {
    return (
      <div className='story'>
        <span className='label'>
          {this.props.title}
          {this.renderTooltip()}
        </span>
        <p
          className='text rich-text--light'
          dangerouslySetInnerHTML={{ __html: this.props.value || '-' }}
        />
      </div>
    )
  }
}

export default observer(Paragraph)
